import { render, staticRenderFns } from "./UserManagerEditTabInformation.vue?vue&type=template&id=a2947e5a"
import script from "./UserManagerEditTabInformation.vue?vue&type=script&lang=js"
export * from "./UserManagerEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./UserManagerEditTabInformation.vue?vue&type=style&index=0&id=a2947e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports